import React from 'react'

const TermsFirst = () => {
    return (
        <>
            <div className="terms__content-explain-text">
                <div className="terms__content-explain-text-wrap">
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit laborum officia minus pariatur, ratione sint.</p>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit laborum officia minus pariatur, ratione sint.</p>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit laborum officia minus pariatur, ratione sint.</p>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit laborum officia minus pariatur, ratione sint.</p>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit laborum officia minus pariatur, ratione sint.</p>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit laborum officia minus pariatur, ratione sint.</p>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit laborum officia minus pariatur, ratione sint.</p>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit laborum officia minus pariatur, ratione sint.</p>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugit laborum officia minus pariatur, ratione sint.</p>
                </div>
            </div>

            <div className="terms__content-explain-agreement">
                <div className="terms__content-explain-agreement-wrap">
                    <input type="checkbox" id="agreement" name="agreement" value="agreement"/>
                    <label htmlFor="agreement">I agree to the terms and conditions</label>
                </div>
            </div>
        </>
    )
}

export default TermsFirst
